import { useState, useEffect, ChangeEvent, MouseEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorPage from "../error/404";
import { api, checkMailerToken } from "../../../services/apis/auth-api/apiUrl";
import { changePassCredentialProps } from "../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";
import { UPDATE_PASSWORD_END_POINT } from "../../../config/config";
import { Helmet } from "react-helmet";
import pathConstant from "../../../utils/path.constant";

export default function ChangePassword (){
    const [tokenIsValid, setTokenIsValid] = useState<boolean>(false);
    const [changePassCredentials, setChangePassCredentials] = useState<changePassCredentialProps>({
        password : '',
        confirm_password : ''
    });
    const [updatePassStatus, setUpdatePassStatus] = useState<string>('');
    const [passwordUpdated, setPasswordUpdated] = useState<boolean>(false);
    const location = useLocation();

    const param = new URLSearchParams(location.search);
    const token = param.get('mailerToken') || '';
    const navigate = useNavigate();

    useEffect(()=>{
        
        async function checkToken (){
            try{
                await checkMailerToken(token);
                setTokenIsValid(true);
            }catch(e){
                setTokenIsValid(false);
            }
        };

        checkToken ();

    },[changePassCredentials, token]);

    const updatePasswordsCredentials = (e : ChangeEvent<HTMLInputElement>) =>{
        const {name, value} = e.target;
        
        setChangePassCredentials({
            ...changePassCredentials,
            [name] : value,
        });
    }

    const savePassword = async(e : MouseEvent<HTMLButtonElement>) =>{
        e.preventDefault();

        const credIsNotComplete = Object.values(changePassCredentials).some(value => value === '');
        if(credIsNotComplete) return setUpdatePassStatus('All fields are required!');

        if(changePassCredentials.password !== changePassCredentials.confirm_password){
            return setUpdatePassStatus('Passwords dont match!');
        }

        if(changePassCredentials.password.length < 8) return setUpdatePassStatus('Password must be atleast 8 characters.');

        setUpdatePassStatus('Processing....');
        
        try{
            await api.post(UPDATE_PASSWORD_END_POINT, changePassCredentials, {headers : {'Authorization' : 'Bearer '+token}})
            setPasswordUpdated(true);
            setUpdatePassStatus('Password updated!');
            setTimeout(()=>{setUpdatePassStatus('Redirecting to login page.....')},1000);
            setTimeout(()=>{navigate(pathConstant.SIGNIN)},2000);
        }catch(e){
            const error = (e as AxiosError);
            switch (error.response?.status) {
                case 401:
                    setUpdatePassStatus('Change password link has expired!');
                    break;
                case 400:
                    setUpdatePassStatus('Passwords dont match!');
                    break;
                case 500:
                    setUpdatePassStatus('Something went wrong!');
                    break;
                default:
                    break;
            }
        }
    }

    if(!tokenIsValid){
        return (<ErrorPage />);
    }
    
    return (
        <div className='main-container'>
            <Helmet>
                <title>Change Password</title>
            </Helmet>
            <div className='auth-card'>
                <div className='card-header'>
                    <h1>
                        <FontAwesomeIcon icon={faLock} />
                        ****
                    </h1>
                    <h1>
                        Change Password
                    </h1>
                    <p className="text-xs my-4">
                        <FontAwesomeIcon icon={faCircleExclamation} />
                        Note : This form will expire in 3 minutes.
                    </p>
                </div>
                <div className=''>
                    <div className={passwordUpdated ? 'text-green-600' : 'text-red-500'}>
                        {updatePassStatus}
                    </div>
                    <form>
                        <div className='input-container'>
                            <input type="password" name="password" onChange={updatePasswordsCredentials} value={changePassCredentials.password} className='text-box' placeholder="Password" />
                        </div>
                        <div className='input-container'>
                            <input type="password" name="confirm_password" onChange={updatePasswordsCredentials} value={changePassCredentials.confirm_password} className='text-box' placeholder="Confirm Password" />
                        </div>
                        <div className='input-container'>
                            <button type="button" onClick={savePassword} className='button button-vcc-primary'>
                                Update Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}